import React, { useEffect, useState } from 'react'

import Modal from 'components/common/Modal'
import Input from 'components/common/Input'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Text from 'components_new/atoms/Text'

import BaseUrlField from '../BaseUrlField'

import Styles from './styles.module.css'

const EditSlug = ({
  visible,
  onClose,
  customerSlug,
  slug,
  onSave,
  setAlert,
  resetAlert
}) => {
  const [newSlug, setNewSlug] = useState(slug)
  const [locked, setLocked] = useState(true)

  useEffect(() => {
    if (visible) {
      setLocked(true)
      setNewSlug(slug)
    }
  }, [visible])

  return (
    <Modal
      visible={visible}
      onClose={() => onClose()}
      header={'Redigera Bas-URL'}
      actions={
        <>
          <Button onClick={() => onClose()} variant="text">
            Avbryt
          </Button>
          <Button
            onClick={() => {
              onSave({ slug: newSlug })
              onClose()
            }}
          >
            Spara
          </Button>
        </>
      }
    >
      <Box sx={{ display: 'flex', gap: 1 }}>
        <BaseUrlField
          customerSlug={customerSlug}
          slug={''}
          className={Styles['slug-width-limit']}
        />
        <Input
          size="large"
          withLock
          locked={locked}
          setLocked={() =>
            setAlert({
              header: 'Redigera bas-URL',
              content: (
                <Text variant="body1">
                  Att redigera bas-URL för detta API påverkar direkt alla parter
                  som för närvarande använder ditt API. Det kan orsaka problem.
                </Text>
              ),
              onCancel: () => resetAlert(),
              onOk: () => {
                setLocked(false)
                resetAlert()
              },
              cancelText: 'Avbryt',
              okText: 'Lås upp'
            })
          }
          lockStyle={Styles.lock}
          containerClassName={'width-100'}
          value={newSlug}
          onChange={(e) => setNewSlug(e)}
        />
      </Box>
    </Modal>
  )
}

export default EditSlug
